import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VendorsService {

  constructor(private http: HttpClient) { }

  getVendorList(appId?) {
    const env = 'production';
    const _this = this;
    const url = '/dashboard/ujmanalytics/vendor?env=' + env;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  addVendor(_vendorData) {
    const _this = this;
    const url = '/dashboard/ujmanalytics/vendor';
    return this.http.put<any>(url, _vendorData).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  updateVendor(_vendorData) {
    const _this = this;
    const url = '/dashboard/ujmanalytics/vendor';
    return this.http.post<any>(url, _vendorData).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  deleteVendor(_vendorId) {
    const _this = this;
    const url = '/dashboard/ujmanalytics/vendor/delete?vid=' + _vendorId;
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  attachVendor(vendor_ids, app_id) {
    const _this = this;
    const url = '/dashboard/ujmanalytics/vendor/update';
    const payload: any = {
      vend_ids: vendor_ids,
      apid: app_id
    };
    return this.http.post<any>(url, payload).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getPushcredentials(appId?) {
    const env = 'production';
    const _this = this;
    const url = '/dashboard/ujmanalytics/vendor/pushcredentials';
    return this.http.get<any>(url).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }
}
